import type { Strings } from '../index.ts';

/**
 * Das Vokabular von SponsorBlock, geteilt von den Einstellungen (das Kategorien-Raster) und der
 * Watch-Seite (Streifen auf der Leiste, Hinweise, Kapitel-Marken).
 *
 * Die Namen müssen in eine Kapitel-Marke passen, deshalb ist jeder so kurz wie er sein kann, ohne zum
 * Rätsel zu werden: `music_offtopic` heißt „Ohne Musik“ und nicht „Abschnitt ohne Musik“, und
 * `interaction` heißt „Interaktionshinweis“ und nicht „Aufforderung zur Interaktion“, was in einer Marke
 * über zwei Zeilen ginge.
 */
export const sponsorBlock: Strings['sponsorBlock'] = {
  category: {
    sponsor: 'Sponsor',
    selfpromo: 'Eigenwerbung',
    interaction: 'Interaktionshinweis',
    intro: 'Intro',
    outro: 'Outro',
    preview: 'Vorschau',
    music_offtopic: 'Ohne Musik',
    filler: 'Füllmaterial',
  },
};
